import { Image as ImageType } from '@yleisradio/areena-types';
import Image from 'next/image';
import React from 'react';
import { defaultLoader, loaderUrl } from 'utils/images';
import styles from './ChannelHeader.module.scss';

type Props = {
  alt: string;
  image: ImageType;
};

export const ChannelLogo: React.FC<Props> = ({ alt, image }) => {
  return (
    <Image
      key={image.id}
      src={loaderUrl(image)}
      alt={alt}
      loader={defaultLoader}
      width={219}
      height={53}
      priority
      className={styles.channelLogo}
    />
  );
};
